import { notify } from 'utils/reduxUtils';

export const types = {
  BUILD_FILTERS_ERROR: 'tasks/listPage/BUILD_FILTERS_ERROR',
  BUILD_FILTERS_SUCCESS: 'tasks/listPage/BUILD_FILTERS_SUCCESS',
  FETCH_TASKS_ERROR: 'tasks/listPage/FETCH_TASKS_ERROR',
  FETCH_TASKS_REQUEST: 'tasks/listPage/FETCH_TASKS_REQUEST',
  FETCH_TASKS_SUCCESS: 'tasks/listPage/FETCH_TASKS_SUCCESS',
  FILTERS_APPLY: 'tasks/listPage/FILTERS_APPLY',
  FILTERS_SET: 'tasks/listPage/FILTERS_SET',
  PAGINATION_SET: 'tasks/listPage/PAGINATION_SET',
};

export const buildFilters = {
  error: notify(
    (error) => ({
      type: types.BUILD_FILTERS_ERROR,
      payload: error,
    }),
    'Error building filters',
  ),
  success: ({ teamMembers }) => ({
    type: types.BUILD_FILTERS_SUCCESS,
    payload: { teamMembers },
  }),
};

export const fetchTasks = {
  error: notify(
    (error) => ({
      type: types.FETCH_TASKS_ERROR,
      payload: error,
    }),
    'Error fetching tasks',
  ),
  request: () => ({
    type: types.FETCH_TASKS_REQUEST,
  }),
  success: ({ count, tasks }) => ({
    type: types.FETCH_TASKS_SUCCESS,
    payload: { count, tasks },
  }),
};

export const filters = {
  // add filters to store and trigger the page to reload
  apply: ({ assignedToIn, quoteNumber, statusIn }) => ({
    type: types.FILTERS_APPLY,
    payload: { assignedToIn, quoteNumber, statusIn },
  }),
  // add filters to store
  set: ({ assignedToIn, quoteNumber, page = 1, statusIn }) => ({
    type: types.FILTERS_SET,
    payload: { assignedToIn, quoteNumber, page, statusIn },
  }),
};

export const pagination = {
  set: ({ page }) => ({
    type: types.PAGINATION_SET,
    payload: { page },
  }),
};
